import React from 'react';
import ApolloDataExportHistoryItem from '../Domain/ApolloDataExportHistoryItem.js';
import AuthService from './authService.js';

class ApolloDataExportHistoryService extends React.Component {
  static GetHistory(id) {
    const authService = AuthService.getInstance();
    const url = `/api/ApolloDataExportHistory/GetAllByApolloDataExportId/${id}`;
    return authService.CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map((item) => new ApolloDataExportHistoryItem(item));
    }

    return mappedItems;
  }
}

export default ApolloDataExportHistoryService;
